exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.filter-category[data-v-21d1e4e9] {\n  font-weight: bold;\n  font-size: 1.45em;\n}\n.toggle-link[data-v-21d1e4e9] {\n  cursor: pointer;\n  padding: 0 12px;\n}\n.toggle-window[data-v-21d1e4e9] {\n  border: 2px solid #f1f1f1;\n  padding: 8px;\n  margin-bottom: 4px;\n}\n#list-link[data-v-21d1e4e9] {\n  border-left: 2px solid #f1f1f1;\n}\n.toggle-bar[data-v-21d1e4e9] {\n  padding-bottom: 8px;\n  border-bottom: 2px solid #f1f1f1;\n}\np.no-vertical-margin[data-v-21d1e4e9] {\n  margin-bottom: 0;\n  margin-top: 0;\n}\n.project[data-v-21d1e4e9] {\n  margin-bottom: 1rem;\n}\n.list-pane[data-v-21d1e4e9] {\n  overflow-y: scroll;\n}\n@media (max-width: 650px) {\n.list-pane[data-v-21d1e4e9] {\n    max-height: 80%;\n}\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-21d1e4e9","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/projects/Projects.vue
// module id = kE7e
// module chunks = 1